// 服务类
let mockBaseUrl = 'http://rap2api.taobao.org/app/mock/228718'
export default {
  // 获取保单列表
  '/sale/policy/policyList': mockBaseUrl + '/sale/policy/policyList',
  // 获取保单详情
  '/sale/policy/policyDetail': mockBaseUrl + '/sale/policy/policyDetail'
}
